import { Paragraph, ParagraphProps } from 'theme-ui';

export interface CardLabelProps extends ParagraphProps {}

const CardLabel: React.FC<CardLabelProps> = ({ sx, ...props }) => (
  <Paragraph as="h4" variant="label" sx={{ color: 'muted', ...sx }} {...props} ref={null} />
);

export default CardLabel;
